import { useMutation } from '@tanstack/react-query'
import api from '@/lib/api'
import { useAccessToken } from '@/features/auth/state/auth'

export function useSignManyAgreements() {
  const token = useAccessToken()
  return useMutation({
    mutationFn: async (ids: string[]) => {
      // ajuste a rota/body conforme sua API
      const { data } = await api.post(
        '/agreements/sign-many',
        { ids },
        { headers: { Authorization: `Bearer ${token}` } }
      )
      return data
    }
  })
}
